import {useEffect, useState} from "react";
import {useApp} from "../Context";

export default function PaymentOptions({handle1, handle2}){
    const {cfg} = useApp()
    const [payments, setPayments] = useState([])

    useEffect(() => {
        setPayments(cfg.payments ?? [])
    }, []);

    useEffect(()=>{
        console.log(payments)
    },[payments])
    return(
        <>
            <h5 className="fw-bold text-dark mt-3">Betalning</h5>
            {(payments.includes("swish") || payments.length === 0) &&
                <button
                className="btn w-100 fw-semibold d-flex align-items-center justify-content-center mb-2"
                style={{
                    height: "50px",
                    border: "2px solid #45B128",
                }}
                onClick={handle1}
            >
                <img
                    src="https://hjarnkraft.se/wp-content/uploads/2023/04/Swish-Logo-Secondary-Light-BG.png"
                    alt="Swish"
                    style={{height: "90%", objectFit: "contain"}}
                />
            </button>}
            {payments.includes("viva") &&
            <button
                className="btn btn-primary w-100 fw-bold d-flex gap-2 text-muted align-items-center justify-content-center primaryText"
                style={{height: "50px"}}
                onClick={handle2}
            >
                <span className="fs-5 m-0">Kort</span> <i className="bi bi-credit-card fs-4 m-0"></i>

            </button>
            }
        </>
    )
}
